export const formatDate = (dateString: string): string => {
  // Parse ISO string directly without timezone conversion
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${day}-${month}-${year}`;
};

export const formatDateTime = (dateString: string): string => {
  // Parse ISO string directly without timezone conversion
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${day}-${month}-${year} ${hours}:${minutes}`;
};